import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { userColumnDefs, defaultColDef } from '../_utils/definitions-config';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function UserTable({ rowData, editHandler, deleteHandler }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='flex items-center justify-left'>
        <IconButton onClick={() => editHandler(params.data)}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={() => deleteHandler(params.data)}>
          <DeleteIcon />
        </IconButton>
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };
  return (
    <div className='ag-theme-alpine' style={{ height: '85vh', width: '100%' }}>
      <AgGridReact
        columnDefs={userColumnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={10}
        paginationAutoPageSize={true}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        rowHeight={50}
        frameworkComponents={frameworkComponents}
      />
    </div>
  );
}

export default UserTable;
